// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"60d5f253","787":"6f0453fb"}[chunkId] + ".chunk.js";
};